"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.send = send;
exports.getSmsTemplate = getSmsTemplate;
exports.getSmsList = getSmsList;
exports.listSms = listSms;
exports.createSms = createSms;
exports.updateSms = updateSms;
exports.deleteSms = deleteSms;

var _request = _interopRequireDefault(require("@/utils/request"));

function send(data) {
  return (0, _request.default)({
    url: '/sendSms/send',
    method: 'post',
    data: data
  });
}

function getSmsTemplate() {
  return (0, _request.default)({
    url: '/sendSms/getTemplate',
    method: 'get'
  });
}

function getSmsList(id) {
  return (0, _request.default)({
    url: '/sendSms/list',
    method: 'get',
    params: {
      id: id
    }
  });
}

function listSms(query) {
  return (0, _request.default)({
    url: '/sendSms/listSms',
    method: 'get',
    params: query
  });
}

function createSms(data) {
  return (0, _request.default)({
    url: '/sendSms/create',
    method: 'post',
    data: data
  });
}

function updateSms(data) {
  return (0, _request.default)({
    url: '/sendSms/update',
    method: 'post',
    data: data
  });
}

function deleteSms(data) {
  return (0, _request.default)({
    url: '/sendSms/delete',
    method: 'post',
    data: data
  });
}